<div class="profile-img-wrapper">
  <slotcom-avatar
    [userId]="profileUser.id"
    [isFriend]="friendship() === 1"
    class="lg"></slotcom-avatar>
</div>
@if (currentUser.canChangeName && isSelf) {
  <div class="username text-center">
    <span
      class="editable"
      (click)="manageName()">
      <span class="name">{{ profileUser.nickName }}</span>
      <span class="icons-sprite tiny pencil"></span>
      @if (showNotification()) {
        <span class="tooltipText"><span class="arrow"></span>{{ 'home.profile.nickName.tooltip' | translate }}</span>
      }
    </span>
  </div>
} @else {
  <div class="username w-100 text-center">
    <span>{{ profileUser.nickName }}</span>
  </div>
}
@if (isSelf) {
  <slotcom-button
    class="c-button--round-settings"
    (safeClick)="manageProfile()"
    audioType="functionality">
    <span class="icons-sprite tiny settings-outline"> </span>
  </slotcom-button>
}
@if (isSelf) {
  <div>
    @if (linkLogins()) {
      <div class="button-position">
        @if (!profileUser.hasFacebook) {
          <div class="d-flex justify-content-center">
            <slotcom-button
              (safeClick)="linkLogin('Facebook')"
              class="c-button--facebook"
              audioType="functionality">
              <span class="icons-sprite tiny facebook-rounded"></span>
              <span class="fb-btn-text">{{
                'home.profile.save-progress-facebook' | translate: { platform: 'Facebook' }
              }}</span>
            </slotcom-button>
          </div>
        } @else {
          <div class="d-flex justify-content-center align-items-center min-text-width">
            <span class="icons-sprite tiny facebook-rounded"></span>
            <span
              [innerHTML]="'home.profile.progress-saved-on' | translate: { platform: 'Facebook' }"
              class="text-saved"></span>
          </div>
        }

        @if (useAppleId()) {
          <div>
            @if (!profileUser.hasAppleId) {
              <div>
                <slotcom-button
                  (safeClick)="linkLogin('AppleId')"
                  class="c-button--apple"
                  audioType="functionality">
                  <span class="icons-sprite tiny apple-black"></span>
                  <span class="apple-btn-text">{{
                    'home.profile.save-progress' | translate: { platform: 'Apple' }
                  }}</span>
                </slotcom-button>
              </div>
            } @else {
              <div class="d-flex justify-content-center align-items-center min-text-width">
                <span class="icons-sprite tiny apple"></span>
                <span
                  [innerHTML]="'home.profile.progress-saved-on' | translate: { platform: 'Apple' }"
                  class="text-saved"></span>
              </div>
            }
          </div>
        }
        @if (useGooglePlay()) {
          <div>
            @if (!profileUser.hasGooglePlay) {
              <div>
                <slotcom-button
                  (safeClick)="linkLogin('GooglePlay')"
                  class="c-button--googlePlay"
                  audioType="functionality">
                  <span class="icons-sprite tiny google"></span>
                  <span class="googlePlay-btn-text">{{
                    'home.profile.save-progress' | translate: { platform: 'GooglePlay' }
                  }}</span>
                </slotcom-button>
              </div>
            } @else {
              <div class="d-flex justify-content-center align-items-center min-text-width">
                <span class="icons-sprite tiny google"></span>
                <span
                  [innerHTML]="'home.profile.progress-saved-on' | translate: { platform: 'GooglePlay' }"
                  class="text-saved"></span>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
} @else {
  @if (!isSelf) {
    <div class="button-position text-center">
      @if (friendship() === 0) {
        <slotcom-button
          (safeClick)="sendFriendRequest()"
          audioType="functionality"
          class="c-button--pink">
          <div>
            <span class="icons-sprite tiny add-friend"></span>
          </div>
          <span>{{ 'home.friends.sendFriendRequest' | translate }}</span>
        </slotcom-button>
      }
      @if (friendship() === 1) {
        <slotcom-button
          (safeClick)="unfriend()"
          audioType="functionality"
          class="c-button--red">
          <div>
            <span class="icons-sprite tiny delete-friend"></span>
          </div>
          <span>{{ 'home.friends.unfriend' | translate }}</span>
        </slotcom-button>
      }
      @if (friendship() === 2) {
        <div class="d-flex flex-column">
          <slotcom-p
            class="mb-2"
            [text]="'home.profile.acceptRequest' | translate"></slotcom-p>
          <div class="d-inline-flex">
            <slotcom-button
              (safeClick)="rejectFriendRequest()"
              audioType="functionality"
              class="c-button--pink small">
              <div>
                <span class="icons-sprite tiny cross"></span>
              </div>
            </slotcom-button>

            <slotcom-button
              (safeClick)="acceptFriendRequest()"
              audioType="functionality"
              class="c-button--pink small">
              <div>
                <span class="icons-sprite tiny tick"></span>
              </div>
            </slotcom-button>
          </div>
        </div>
      }
      @if (friendship() === 3) {
        <slotcom-button
          (safeClick)="cancelFriendRequest()"
          audioType="functionality"
          class="c-button--red">
          <div>
            <span class="icons-sprite tiny delete-friend"></span>
          </div>
          <span>{{ 'home.friends.cancelFriendRequest' | translate }}</span>
        </slotcom-button>
      }
    </div>
  }
}
